import { apiClient } from './apiClient';

export type LikeTargetType = 'news' | 'comment';

export interface LikeUser {
  id: number;
  username: string | null;
}

export interface LikeNewsTarget {
  id: number;
  title: string | null;
  slug: string | null;
  content: string;
}

export interface LikeCommentTarget {
  id: number;
  content: string | null;
}

export interface Like {
  id: number;
  createdOn: string;
  user: LikeUser;
  targetType: LikeTargetType;
  target: LikeNewsTarget | LikeCommentTarget;
}

export interface LikeListResponse {
  data: Like[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface LikeStats {
  daily: number;
  monthly: number;
  yearly: number;
  total: number;
}

export const likesService = {
  async getStats(): Promise<LikeStats> {
    return apiClient.get<LikeStats>('/likes/stats');
  },

  async searchLikes(
    search?: string,
    page: number = 1,
    limit: number = 20,
    targetType?: LikeTargetType,
  ): Promise<LikeListResponse> {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    if (targetType) params.append('targetType', targetType);
    return apiClient.get<LikeListResponse>(`/likes?${params.toString()}`);
  },

  async deleteLike(id: number): Promise<void> {
    await apiClient.delete<void>(`/likes/${id}`);
  },
};
